import {render} from 'preact';
import {jsonAnswerMock1} from '../data/get-mock-data';
import WidgetComponent from '../components/widget/index.jsx';
import ShareComponent from '../components/share';
import WidgetModel from '../model/widget';
import ProgressModule from '../moduls/progress';

const OBJECT_FROM_WINDOW_NAME = `MKWidgetPolls`;
const DEFAULT_WIDGET_PLACE = `rosatom-game`;

/**
 * Набросок разбора структуры виджета.
 * Выделяю отдельные части без ветвлений, для того чтобы в layout-е выводящем всё сразу, можно было выводить часть виджета до ветвления.
 */
// const nextBrunches = function (root, modelData) {
//   console.log(`nextBrunches 789`);
//   const result = []
//   if (modelData.steps.has(root)){
//     if (`next` in modelData.steps.get(root)) {
//       result.push(modelData.steps.get(root).next);
//     }
//     if (`answers` in modelData.steps.get(root)) {
//       modelData.steps.get(root).answers.forEach((element) => {
//         if (`next` in element) {
//           result.push(element.next);
//         }
//       });
//     }
//     const resultSet = new Set(result);
//     resultSet.delete(root);
//     return Array.from(resultSet);
//   }
//   return [];
// };
//
// const toTree = function(modelData, start, ban = []) {
//   console.log(`toTree 789`);
//   const banSet = new Set(ban);
//   const nextBrunchesArray = nextBrunches(start, modelData).map((element) => {
//     if (!banSet.has(element)){
//       return toTree(modelData, element, [...ban, start]);
//     }
//   });
//   const str = (Array.isArray(nextBrunchesArray) && (nextBrunchesArray.length > 1)) ? `[${nextBrunchesArray.join(', ')}]` : nextBrunchesArray[0];
//   return (str) ? `${start} -> ${str}` : `${start}`;
// };

/**********************************************************/

export default class Loader {
  static start() {
    const responseData = Loader.loadData();
    // console.log(`loader`);
    // console.log(responseData);
    const modelData = new WidgetModel(responseData[0]);
    // console.log(`modelData`);
    // console.log(modelData);
    const progress = new ProgressModule(modelData.start, responseData[0].steps);
    // console.log(`progress`);
    // console.log(progress);

    render(<ShareComponent />, document.querySelector('.header__share-wrapper'));
    const widgets = (OBJECT_FROM_WINDOW_NAME in window) ? window.MKWidgetPolls : [];

    for (let widget of widgets) {
      // console.log(widgets);
      // console.log(widget);
      const selector = ('place' in widget) ? `#${widget.place}` : `#${DEFAULT_WIDGET_PLACE}`;
      // console.log(selector);
      render(<WidgetComponent data={modelData} progress={progress}/>, document.querySelector(selector));
    }
  }

  static loadData() {
    // позже будет реализовано взаимодействие с сервером
    return JSON.parse(jsonAnswerMock1);
  }
}



// WEBPACK FOOTER //
// ./moduls/loader.jsx